import { render, staticRenderFns } from "./PopUpGetBrouillon.vue?vue&type=template&id=54fc6baa&scoped=true"
import script from "./PopUpGetBrouillon.vue?vue&type=script&lang=js"
export * from "./PopUpGetBrouillon.vue?vue&type=script&lang=js"
import style0 from "./PopUpGetBrouillon.vue?vue&type=style&index=0&id=54fc6baa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54fc6baa",
  null
  
)

export default component.exports